/* eslint-disable react/no-array-index-key */
import { Box, Typography, Alert, Fade } from "@mui/material";
import { Check as CheckIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import Button from "../primitives/Button";

const UploadProgressOverlay = ({ uploadStatus, uploadProgress, onReset }) => {
  if (uploadStatus === "success") {
    return (
      <Fade in timeout={300}>
        <Box sx={{ textAlign: "center", py: 8 }}>
          <CheckIcon color="success" sx={{ fontSize: 80, mb: 3 }} />
          <Typography variant="h4" gutterBottom>
            Upload Completed Successfully!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Your CSV file has been processed and is ready for use.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={onReset}
            startIcon={<RefreshIcon />}
            name="Upload Another File"
          />
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in timeout={300}>
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography variant="h5" gutterBottom>
          {uploadStatus === "uploading"
            ? "Uploading File..."
            : uploadStatus === "error"
              ? "Upload Failed"
              : "Processing..."}
        </Typography>
        <Box sx={{ width: "60%", mx: "auto", mt: 4, mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Box sx={{ width: "100%", mr: 1 }}>
              <Box
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: "#e0e0e0",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${uploadProgress}%`,
                    height: "100%",
                    backgroundColor: uploadStatus === "error" ? "#f44336" : "#4caf50",
                    borderRadius: 4,
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        {uploadStatus === "error" && (
          <>
            <Alert severity="error" sx={{ mt: 3, maxWidth: 400, mx: "auto" }}>
              Upload failed. Please try again.
            </Alert>
            <Button variant="contained" onClick={onReset} sx={{ mt: 3 }} name="Try Again" />
          </>
        )}
      </Box>
    </Fade>
  );
};

export default UploadProgressOverlay;
